import { AxiosError } from "axios"

export class ApiClientError extends Error {
  status?: number
  payload?: unknown

  constructor(message: string, status?: number, payload?: unknown) {
    super(message)
    this.name = "ApiClientError"
    this.status = status
    this.payload = payload
  }

  static fromAxios(error: AxiosError) {
    return new ApiClientError(
      (error.response?.data as any)?.error ?? error.message,
      error.response?.status,
      error.response?.data
    )
  }
}
